import { render, staticRenderFns } from "./FilterList.vue?vue&type=template&id=537a39e6&scoped=true"
import script from "./FilterList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterList.vue?vue&type=style&index=0&id=537a39e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a39e6",
  null
  
)

export default component.exports